/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCrpRecommendations extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCrpRecommendations");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCrpRecommendations.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCrpRecommendations>): BackgroundJobPayloadForPeriodicCrpRecommendations {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCrpRecommendations(), model);
        BackgroundJobPayloadForPeriodicCrpRecommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCrpRecommendations>): BackgroundJobPayloadForPeriodicCrpRecommendations {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCrpRecommendations.newInstance(<BackgroundJobPayloadForPeriodicCrpRecommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCrpRecommendations) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCrpRecommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCrpRecommendations): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCrpRecommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
